<template>
  <v-layout row>
    <v-flex 
      sm12 
      md8 
      offset-md2
      xl6
      offset-xl3>
      <v-card v-if="course.code">
        <v-toolbar 
          color="primary" 
          dark>
          <v-toolbar-title>{{ course.code }} units</v-toolbar-title>          
          <courseForm 
            v-if="course['.key']" 
            :edititem="course"/>
        </v-toolbar>
        <v-card-text>
          <table>
            <tr>
              <th class="text-xs-left">Name:</th>
              <td>{{ course.name }}</td>
            </tr>
            <tr>
              <th class="text-xs-left">Created:</th>
              <td>{{ course.createdUser }}: {{ course.createdDate.seconds | moment("LLLL") }}</td>
            </tr>
            <tr>
              <th class="text-xs-left">Updated:</th>
              <td>{{ course.updateUser }}: {{ course.updateDate.seconds | moment("LLLL") }}</td>
            </tr>
          </table>
        </v-card-text>
        <v-list 
          two-line 
          subheader>
          <v-list-tile 
            v-for="item in units" 
            :key="item.code" 
            :to="{path: '/admin/courses/' + $route.params.course + '/' +item.code}"
            avatar 
          >
            <v-list-tile-content>
              <v-list-tile-title v-text="item.code"/>
              <v-list-tile-sub-title v-text="item.name"/>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-card-text>
          <unitForm 
            :edititem="unit" />
        </v-card-text>
      </v-card>
    </v-flex>

  </v-layout>
</template>

<script>
import adminComponents from "@/components/admin";

export default {
  name: "Course",
  components: {
    ...adminComponents
  },
  data: () => ({
    hidden: false,
    dialog: false,
    valid: true,
    units: null,
    course: null,
    unit: {
      code: null,
      name: null
    }
  }),
  firestore() {
    return {
      course: this.$store.getters.db
        .collection("courses")
        .doc(this.$route.params.course),
      units: this.$store.getters.db
        .collection("courses")
        .doc(this.$route.params.course)
        .collection("units")
        .orderBy("code")
    };
  }
};
</script>
